export const FORMAT = {
    date2Digit: new Intl.DateTimeFormat('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    }),
};
export const MILLISECONDS = (() => {
    const hour = 3600_000;
    const day = 24 * hour;
    return {
        hour,
        day,
    };
})();
export const ago = (() => {
    const hours = (n, now = Date.now()) => new Date(now - n * MILLISECONDS.hour);
    const days = (n, now = Date.now()) => hours(24 * n, now);
    return {
        hours,
        days,
    };
})();
export const coerceDate = (str) => {
    const ms = Date.parse(str);
    if (Number.isNaN(ms)) {
        return undefined;
    }
    return new Date(ms);
};
export const coerceDateOrThrow = (str, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
errorCtor = Error) => {
    const date = coerceDate(str);
    if (date !== undefined) {
        return date;
    }
    throw new errorCtor(`coerceDateOrThrow: ${str}`);
};
//# sourceMappingURL=date.js.map